import { render, staticRenderFns } from "./CmgMealBuilderHeader.vue?vue&type=template&id=be774dea&scoped=true&lang=pug&"
import script from "./cmg-meal-builder-header.ts?vue&type=script&lang=ts&"
export * from "./cmg-meal-builder-header.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMealBuilderHeader.vue?vue&type=style&index=0&id=be774dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be774dea",
  null
  
)

export default component.exports